<!--CARD CONTAINER-->
<section class="container-list" [ngClass]="containerBackgroundCss ? containerBackgroundCss : ''">
  <div class="wrapper" [ngClass]="additionalCSS ? additionalCSS : ''">
    <!--CARD CONTAINER HEADING-->
    <h2 *ngIf="showTitle" class="container-list-title">{{ title }}</h2>
    <!--END CARD CONTAINER HEADING-->
    <!--CARD CONTAINER DESCRIPTION-->
    <p *ngIf="showDescription" class="container-list-lead">{{ description }}</p>
    <!--END CARD CONTAINER DESCRIPTION-->
    <!--CARD CONTAINER CARD LIST-->
    <div>
      <!--NOTE: Allow ng-content or another block of elements to be projected into this banner-->
      <ng-content> </ng-content>
    </div>
    <!--END CARD CONTAINER LIST-->
  </div>
</section>
<!--END CARD CONTAINER-->
